$('.is-state-animation').css('visibility', 'hidden')

$(window).scroll(function() {
  $('.is-state-animation').each(function() {
    var pos = $(this).offset().top
    var scroll = $(window).scrollTop()
    var windowHeight = $(window).height()
    if (scroll > pos - windowHeight + windowHeight / 4) {
      $(this)
        .css('visibility', 'visible')
        .addClass('is-animated')
    }
  })
})
